const MODULE = 'AXIS_ADMIN'
export const SCREEN_CHANGED = `${MODULE}/SCREEN_CHANGED`

export const SCREEN = {
  EDITOR: 'editor',
  IMPORT: 'import'
}
